<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <template #default>
          <dx-button
            icon="menu"
            styling-mode="text"
            @click="toggleMenuFunc"
          />
        </template>
      </dx-item>
      <dx-item
        location="before"
        css-class="header-title dx-toolbar-label"
      >
        <div>
            <DxSelectBox
            :data-source="get_groups"
            display-expr="NAME"
            value-expr="ID"
            v-model:value="group_main_id"
            @item-click="wtcGroup"
            :width="450"
          />
        </div>
      </dx-item>
      <dx-item
        v-if="title"
        location="after"
        css-class="header-title dx-toolbar-label"
      >
        <div>
          <img src="logo.png" style="width:145px;" />
        </div>
      </dx-item>

      <dx-item
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
      <template #default>
          <div>
            <dx-button
              class="user-button authorization"
              :width="200"
              height="100%"
              styling-mode="text"
            >
              <user-panel :username="user_name" :menu-items="userMenuItems" menu-mode="context" />
            </dx-button>
          </div>
        </template>
      </dx-item>
      
      <template #menuUserItem>
        <user-panel
          :username="user_name"
          :menu-items="userMenuItems"
          menu-mode="list"
        />
      </template>
    </dx-toolbar>
    <popupUserSettings
      :open="openUserSettings"
      @popup-closed="closePopupUserSettings"
    />
  </header>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DxSelectBox from 'devextreme-vue/select-box';
import ArrayStore from "devextreme/data/array_store";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import UserPanel from "../component.utils/user-panel.vue";
import popupUserSettings from "../component.utils/user-settings.vue"; 
import http from "../../api/http"; 
import auth from "../../auth";
var _ = require("lodash");
var _this = null;
export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function
  },
  data() {
    return {
      openUserSettings: false,
      userMenuItems : [{
          text: "Perfil del Usuario",
          icon: "user",
          onClick:function () {
            _this.openUserSettings = true;
          }
        },
        {
          text: "Cambiar Contraseña",
          icon: "key",
          onClick:function () {
            _this.$router.push({name:'change-password-user'});
          }
        },
        {
          text: "Cerrar Sesión",
          icon: "runner",
          onClick:function() {
            http.post("logout", {id:auth.get_user_id()})
            .then((response) => {
                if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                  auth.logOut();
                  _this.$router.push({name:'login-form'});
                } 
            })
            .catch((error) => {
                    console.error(error);
            });
          }
      }],
      user_name:auth.get_user_name(),
      group_main_id:"-1",
    };
  },
  computed: {
    get_groups() {
        return new ArrayStore({
            data: auth.get_Groups(),
            key: "ID",
        });
    }
  },
  
  mounted(){
    _this = this;
    this.group_main_id=this.$store.getters.getIdMainGroup;
    this.$event.on("closeSettingUser", () => {
      this.openUserSettings = false;
    });
  },
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
    popupUserSettings,
    DxSelectBox
  },
  methods: {
    closePopupUserSettings() {
      this.openUserSettings = false;
    },
    wtcGroup(e){
      console.log(e.itemData);
      auth.set_id_group_active(e.itemData.id_group);
      auth.set_id_subgroup_active(e.itemData.id_subgroup);
      auth.set_id_role_active(e.itemData.id_role);
    }
  },
};
</script>

<style lang="scss" >
@import "../../themes/generated/variables.base.scss";
@import "../../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 16px;
  }
}
.authorization > .dx-button-content {
    padding: 16px;
}
</style>
